ParentHandler = App.loadClass 'portal::handlers/convert/Parent_Handler'

class exports.Delivery_Handler extends ParentHandler
    init: () ->
        @subHandler = 'portal::handlers/convert/Delivery_Dialog_Handler'
        @filters = 'backend/portal/delivery/get-filter-data'
        super()
